var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton, BForm, BFormGroup, BFormSelect, BInputGroup } from "bootstrap-vue";
import { computed, ref } from "vue";
import { useRouter } from "vue-router/composables";
import { useSelectableObjectStores } from "@/composables/useObjectStores";
import { useHistoryStore } from "@/stores/historyStore";
import localize from "@/utils/localization";
import { fetchHistoryContentsSizeSummary } from "./service";
import { buildTopNDatasetsBySizeData, byteFormattingForChart, useAdvancedFiltering, useDataLoading, useDatasetsToDisplay, } from "./util";
import BarChart from "./Charts/BarChart.vue";
import OverviewPage from "./OverviewPage.vue";
import RecoverableItemSizeTooltip from "./RecoverableItemSizeTooltip.vue";
import SelectedItemActions from "./SelectedItemActions.vue";
import WarnDeletedDatasets from "./WarnDeletedDatasets.vue";
import FilterObjectStoreLink from "@/components/Common/FilterObjectStoreLink.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HistoryStorageOverview',
    props: {
        historyId: null
    },
    setup(__props) {
        const props = __props;
        const router = useRouter();
        const { getHistoryNameById, getHistoryById } = useHistoryStore();
        const activeVsDeletedTotalSizeData = ref(null);
        const { numberOfDatasetsToDisplayOptions, numberOfDatasetsToDisplay, numberOfDatasetsLimit, datasetsSizeSummaryMap, topNDatasetsBySizeData, isRecoverableDataPoint, onUndeleteDataset, onPermanentlyDeleteDataset, } = useDatasetsToDisplay();
        const { isLoading, loadDataOnMount } = useDataLoading();
        const { isAdvanced, toggleAdvanced, inputGroupClasses, faAngleDoubleDown, faAngleDoubleUp } = useAdvancedFiltering();
        const { selectableObjectStores, hasSelectableObjectStores } = useSelectableObjectStores();
        const objectStore = ref(null);
        const canEditHistory = computed(() => {
            var _a;
            const history = getHistoryById(props.historyId);
            return (_a = (history && !history.purged && !history.archived)) !== null && _a !== void 0 ? _a : false;
        });
        function onChangeObjectStore(value) {
            objectStore.value = value;
            reloadDataFromServer();
        }
        function reloadDataFromServer() {
            return __awaiter(this, void 0, void 0, function* () {
                const allDatasetsInHistorySizeSummary = yield fetchHistoryContentsSizeSummary(props.historyId, numberOfDatasetsLimit, objectStore.value);
                datasetsSizeSummaryMap.clear();
                allDatasetsInHistorySizeSummary.forEach((dataset) => datasetsSizeSummaryMap.set(dataset.id, dataset));
                buildGraphsData();
            });
        }
        loadDataOnMount(reloadDataFromServer);
        function buildGraphsData() {
            const allDatasetsInHistorySizeSummary = Array.from(datasetsSizeSummaryMap.values());
            topNDatasetsBySizeData.value = buildTopNDatasetsBySizeData(allDatasetsInHistorySizeSummary, numberOfDatasetsToDisplay.value);
            activeVsDeletedTotalSizeData.value = buildActiveVsDeletedTotalSizeData(allDatasetsInHistorySizeSummary);
        }
        function buildActiveVsDeletedTotalSizeData(datasetsSizeSummary) {
            const activeDatasetsSize = datasetsSizeSummary
                .filter((dataset) => !dataset.deleted)
                .reduce((total, dataset) => total + dataset.size, 0);
            const deletedDatasetsSize = datasetsSizeSummary
                .filter((dataset) => dataset.deleted)
                .reduce((total, dataset) => total + dataset.size, 0);
            return [
                {
                    id: "active",
                    label: "Active",
                    value: activeDatasetsSize,
                },
                {
                    id: "deleted",
                    label: "Deleted",
                    value: deletedDatasetsSize,
                },
            ];
        }
        function onViewDataset(datasetId) {
            return __awaiter(this, void 0, void 0, function* () {
                router.push({
                    name: "DatasetDetails",
                    params: {
                        historyId: props.historyId,
                        datasetId: datasetId,
                    },
                });
            });
        }
        function onPermDelete(datasetId) {
            onPermanentlyDeleteDataset(buildGraphsData, datasetId);
        }
        function onUndelete(datasetId) {
            onUndeleteDataset(buildGraphsData, datasetId);
        }
        return { __sfc: true, router, getHistoryNameById, getHistoryById, props, activeVsDeletedTotalSizeData, numberOfDatasetsToDisplayOptions, numberOfDatasetsToDisplay, numberOfDatasetsLimit, datasetsSizeSummaryMap, topNDatasetsBySizeData, isRecoverableDataPoint, onUndeleteDataset, onPermanentlyDeleteDataset, isLoading, loadDataOnMount, isAdvanced, toggleAdvanced, inputGroupClasses, faAngleDoubleDown, faAngleDoubleUp, selectableObjectStores, hasSelectableObjectStores, objectStore, canEditHistory, onChangeObjectStore, reloadDataFromServer, buildGraphsData, buildActiveVsDeletedTotalSizeData, onViewDataset, onPermDelete, onUndelete, FontAwesomeIcon, BButton, BForm, BFormGroup, BFormSelect, BInputGroup, localize, byteFormattingForChart, BarChart, OverviewPage, RecoverableItemSizeTooltip, SelectedItemActions, WarnDeletedDatasets, FilterObjectStoreLink, LoadingSpan };
    }
});
